export const LANGUAGE_CONSTANT = {
  en: {
    placeholder: "What would you like to see?",
    search: "Search",
  },
  hindi: {
    placeholder: "आप क्या देखना चाहते है?",
    search: "खोज",
  },
  french: {
    placeholder: "Qu’aimeriez-vous voir ?",
    search: "Recherche",
  },
};
